import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'
import '../../assets/scripts/jquery.waypoints.min.js'
import '../../assets/scripts/jquery.countup.min.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

$('.counter').countUp();

var swiper2 = new Swiper(".section2 .sec2-swiper .mySwiper", {
  speed: 600,
  spaceBetween : 60,
  navigation: {
    nextEl: ".section2 .sec2-swiper .swiper-button-next",
    prevEl: ".section2 .sec2-swiper .swiper-button-prev",
  },
});

var swiper3_year = new Swiper(".section3 .year-swiper .mySwiper", {
  slidesPerView : 3, 
  freeMode: true,
  watchSlidesProgress: true,
  breakpoints: { 
    640: {
      slidesPerView : 5, 
    },
  }
});
var swiper3_text = new Swiper(".section3 .text-swiper .mySwiper", {
  allowTouchMove: false,
  autoHeight: true,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".section3 .year-swiper .swiper-button-next",
    prevEl: ".section3 .year-swiper .swiper-button-prev",
  },
  thumbs: {
    swiper: swiper3_year,
  },
  on: {
    init: function(swiper){
      $('.section3 .year-swiper .mySwiper .swiper-slide').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section3 .year-swiper .mySwiper .swiper-slide').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
      $('.section3 .text-swiper .mySwiper .swiper-slide').removeClass('show-all')
    },
  }
});

var swiper4_tab = new Swiper(".section4 .cont2 .tab-swiper", {
  speed: 600,
  allowTouchMove: false,
  effect : 'fade',
  observer: true,  //开启动态检查器，监测swiper和slide
  observeParents: true,  //监测Swiper 的祖/父元素
  fadeEffect: {
    crossFade: true,
  },
  on:{
    init: function(swiper){
      $('.section4 .cont2 .cont2-tab a').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section4 .cont2 .cont2-tab a').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  }
});

$('.section4 .cont2 .cont2-tab a').on('click',function(){
  let index = $(this).index()
  swiper4_tab.slideTo(index)
})

var swiper4_img1 = new Swiper(".section4 .cont2 .img-swiper1", {
  effect: "coverflow",
  slidesPerView: 1,
  spaceBetween : 0,
  centeredSlides: true,
  speed: 600,
  initialSlide: 0,
  observer: true,  //开启动态检查器，监测swiper和slide
  observeParents: true,  //监测Swiper 的祖/父元素
  coverflowEffect: {
    rotate: 50,
    stretch: 0,
    depth: 200,
    modifier: 1,
    slideShadows: false,
  },
  navigation: {
    nextEl: ".section4 .cont2 .img-swiper1 .swiper-button-next",
    prevEl: ".section4 .cont2 .img-swiper1 .swiper-button-prev",
  },
  breakpoints: { 
    640: {
      slidesPerView : 3, 
      initialSlide: 1,
    },
  }
});
var swiper4_img2 = new Swiper(".section4 .cont2 .img-swiper2", {
  effect: "coverflow",
  slidesPerView: 1,
  spaceBetween : 0,
  centeredSlides: true,
  speed: 600,
  initialSlide: 0,
  observer: true,  //开启动态检查器，监测swiper和slide
  observeParents: true,  //监测Swiper 的祖/父元素
  coverflowEffect: {
    rotate: 50,
    stretch: 0,
    depth: 200,
    modifier: 1,
    slideShadows: false,
  },
  navigation: {
    nextEl: ".section4 .cont2 .img-swiper2 .swiper-button-next",
    prevEl: ".section4 .cont2 .img-swiper2 .swiper-button-prev",
  },
  breakpoints: { 
    640: {
      slidesPerView : 3, 
      initialSlide: 1,
    },
  }
});

$('header .pc-header .header .right-cont .nav ul li .sub-nav.about .about-nav .about-nav-item .nav-item-link a').on('click',function(){
  $('header .pc-header .header .right-cont .nav ul li.active').find('.sub-nav').slideUp(200)
})

if($(window).width() < 768){
  $.each($('.text-swiper .swiper-slide'), function (i, item) {
    if($(item).find('ul li').length > 3){
      $(item).addClass('show-more')
      swiper3_text.update()
    }
  });
}else{
  $('.text-swiper .swiper-slide').removeClass('show-more')
}
// $(window).resize(function(){
//   if($(window).width() < 768){
//     $.each($('.text-swiper .swiper-slide'), function (i, item) {
//       if($(item).find('ul li').length > 3){
//         $(item).addClass('show-more')
//         swiper3_text.update()
//       }
//     });
//   }else{
//     $('.text-swiper .swiper-slide').removeClass('show-more')
//   }
// })

$('.text-swiper .more').on('click',function(){
  $(this).closest('.swiper-slide').addClass('show-all')
  swiper3_text.update()
})

$('header .mob-header>ul>li .sub-title .slide-nav li .slide-cont a').on('click',function(){
  $('.header .right-fun .hamburger').removeClass('active')
  $('.mob-header').removeClass('active')
  $('.pc-header').removeClass('mob-active')
  $('.mob-header>ul>li .sub-title').removeClass('active')
})